import type { MaskedTile as Tile } from '@completto/shared';
import { rotationCandidates } from '@completto/shared';
import { html, View } from 'rune-ts';

export type PoolChipData = {
  tile: Tile;
  highlightForMe: boolean; // 내가 가져갈 수 있는 타일 (✨)
  enabled: boolean;
  onClick: (tileId: string) => void;
};

export class PoolChipView extends View<PoolChipData> {
  override template() {
    const { tile, highlightForMe, enabled } = this.data;
    const num = tile.resolvedNumber ?? tile.number;
    const rotatable = num !== null && rotationCandidates(num).length > 1;
    const cls = enabled
      ? highlightForMe
        ? 'pool-chip-placeable bg-card-gold/30 text-wood-ink ring-2 ring-emerald-500 hover:bg-card-gold/40 cursor-pointer'
        : 'bg-card-navy text-card-gold hover:bg-card-deep cursor-pointer'
      : 'bg-wood-sand/40 text-wood-coffee/60 cursor-not-allowed';
    const ariaLabel =
      num === null
        ? '풀 타일'
        : `풀 타일 ${num}${enabled ? (highlightForMe ? ', 가져오기 가능' : '') : ', 비활성'}`;
    return html`
      <button
        type="button"
        data-tile-id="${tile.id}"
        aria-label="${ariaLabel}"
        class="pool-chip relative shrink-0 w-10 h-12 sm:w-12 sm:h-14 mlandscape:w-10 mlandscape:h-12 rounded-md font-bold text-base mlandscape:text-sm flex items-center justify-center transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 ${cls}"
        ${enabled ? '' : 'disabled'}
      >
        <span>${num}</span>
        ${rotatable ? html`<span class="absolute bottom-0 right-0.5 text-base opacity-50 leading-none">⟲</span>` : ''}
        ${highlightForMe ? html`<span class="absolute -top-1 -right-1 text-card-gold">✨</span>` : ''}
      </button>
    `;
  }

  protected override onMount(): void {
    this.element().addEventListener('click', () => {
      if (this.data.enabled) this.data.onClick(this.data.tile.id);
    });
  }
}
